module.exports = __webpack_public_path__ + "static/about-85fd241d0b9d7d033aee1244f74b633f.jpg";